var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 728,
    height: 586,
    viewBox: "0 0 728 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    opacity: 0.150019,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.946 244.08C521.029 240.173 521.029 233.827 524.946 229.92L615.438 139.65C619.341 135.756 625.66 135.756 629.563 139.65L720.055 229.92C723.972 233.827 723.972 240.173 720.055 244.08L629.563 334.35C625.66 338.244 619.341 338.244 615.438 334.35L524.946 244.08Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    opacity: 0.0375744,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.964 80.1557C212.048 76.2485 212.048 69.9034 215.964 65.9962L266.385 15.6991C270.288 11.8054 276.607 11.8054 280.51 15.6991L330.931 65.9962C334.848 69.9034 334.848 76.2485 330.931 80.1557L280.51 130.453C276.607 134.346 270.288 134.346 266.385 130.453L215.964 80.1557Z",
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    opacity: 0.0659412,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.439 249.15C264.522 245.242 264.522 238.897 268.439 234.99L456.478 47.4131C460.381 43.5194 466.699 43.5194 470.602 47.413L658.641 234.99C662.558 238.897 662.558 245.242 658.641 249.15L470.602 436.727C466.699 440.62 460.381 440.62 456.478 436.727L268.439 249.15Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    opacity: 0.0895647,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.744 244.969C139.509 240.733 132.633 240.742 128.387 244.988L8.45181 364.923C4.20577 369.169 4.19732 376.045 8.43294 380.28L128.074 499.921C132.309 504.157 139.185 504.148 143.431 499.902L263.366 379.967C267.612 375.721 267.62 368.845 263.385 364.61L143.744 244.969ZM62.1931 372.535L135.999 298.729L209.624 372.354L135.818 446.16L62.1931 372.535Z",
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Office Desk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.293 351L201.292 494.767L201.439 494.625L201.405 501.757L284.073 583.951H273.053L201.292 512.567L201.293 583.912H192.588L192.588 515.289L123.608 583.951H111.5L192.588 503.308L192.588 351H201.293Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.613 496.4C217.613 493.639 215.375 491.4 212.613 491.4H182.355C179.594 491.4 177.355 493.639 177.355 496.4V503.814C177.355 506.575 179.594 508.814 182.355 508.814H212.613C215.375 508.814 217.613 506.575 217.613 503.814V496.4Z",
    fill: "#C8DAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mini Board"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.25 148H281.801C284.655 148 286.967 150.304 286.967 153.146V407.6C286.967 410.363 284.781 412.618 282.038 412.741L281.781 412.747V412.747L129.23 412.156C126.385 412.145 124.084 409.844 124.084 407.009V153.146C124.084 150.304 126.397 148 129.25 148Z",
    fill: "#AFA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.778 148H274.33C277.183 148 279.496 150.304 279.496 153.146V407.6C279.496 410.363 277.31 412.618 274.566 412.741L274.31 412.747V412.747L121.758 412.156C118.913 412.145 116.612 409.844 116.612 407.009V153.146C116.612 150.304 118.925 148 121.778 148Z",
    fill: "#141A2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.142 153.317H266.756C270.02 153.317 272.666 155.953 272.666 159.204V399.436C272.666 402.688 270.02 405.323 266.756 405.323H129.142C125.877 405.323 123.231 402.688 123.231 399.436V159.204C123.231 155.953 125.877 153.317 129.142 153.317Z",
    fill: "#283046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.331 397.88H213.959C216.317 397.88 218.229 399.784 218.229 402.133V415.957H172.331C169.973 415.957 168.062 414.052 168.062 411.703V402.133C168.062 399.784 169.973 397.88 172.331 397.88Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.161 411.703H221.431V415.957H217.161V411.703Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.196 397.88H211.824C214.182 397.88 216.094 399.784 216.094 402.133V411.703C216.094 414.052 214.182 415.957 211.824 415.957H170.196C167.838 415.957 165.927 414.052 165.927 411.703V402.133C165.927 399.784 167.838 397.88 170.196 397.88Z",
    fill: "#C8DAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 349.771,
    y: 179,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 344.5,
    y: 179,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.407 192.173C352.407 189.964 354.198 188.173 356.407 188.173H400.246C402.455 188.173 404.246 189.964 404.246 192.173V244.014C404.246 246.224 402.455 248.014 400.246 248.014H356.407C354.198 248.014 352.407 246.224 352.407 244.014V192.173Z",
    fill: "#313A53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    d: "M352.407 192.173C352.407 189.964 354.198 188.173 356.407 188.173H357.679V248.014H356.407C354.198 248.014 352.407 246.224 352.407 244.014V192.173Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.764 231.879C395.074 231.879 395.268 231.544 395.113 231.275L377.805 201.118C377.649 200.845 377.254 200.848 377.102 201.124L360.502 231.281C360.354 231.55 360.548 231.879 360.855 231.879H394.764Z",
    fill: "#83F2D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 127_2",
    opacity: 0.44687,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.94 220.134C397.251 220.134 397.445 219.798 397.29 219.529L387.905 203.279C387.748 203.008 387.355 203.011 387.203 203.286L378.202 219.536C378.053 219.804 378.247 220.134 378.554 220.134H396.94Z",
    fill: "#63CBE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 61_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    x: 446.771,
    y: 179,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    x: 441.5,
    y: 179,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.407 192.173C449.407 189.964 451.198 188.173 453.407 188.173H497.246C499.455 188.173 501.246 189.964 501.246 192.173V244.014C501.246 246.224 499.455 248.014 497.246 248.014H453.407C451.198 248.014 449.407 246.224 449.407 244.014V192.173Z",
    fill: "#313A53"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    x: 461.708,
    y: 207.829,
    width: 25.9191,
    height: 25.7712,
    rx: 0.4032,
    fill: "#83F2D5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    opacity: 0.44687,
    x: 475.766,
    y: 197.782,
    width: 19.7688,
    height: 19.656,
    rx: 0.4032,
    fill: "#63CBE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    d: "M449.407 192.173C449.407 189.964 451.198 188.173 453.407 188.173H454.679V248.014H453.407C451.198 248.014 449.407 246.224 449.407 244.014V192.173Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 61_3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    x: 542.771,
    y: 179,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    x: 537.5,
    y: 179,
    width: 67.6534,
    height: 77.7504,
    rx: 6,
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.407 192.173C545.407 189.964 547.198 188.173 549.407 188.173H593.246C595.455 188.173 597.246 189.964 597.246 192.173V244.014C597.246 246.224 595.455 248.014 593.246 248.014H549.407C547.198 248.014 545.407 246.224 545.407 244.014V192.173Z",
    fill: "#313A53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 571.985,
    cy: 220.714,
    rx: 18.2313,
    ry: 18.1272,
    fill: "#83F2D5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    opacity: 0.44687,
    cx: 580.772,
    cy: 206.3,
    rx: 9.44511,
    ry: 9.3912,
    fill: "#63CBE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    d: "M545.407 192.173C545.407 189.964 547.198 188.173 549.407 188.173H550.679V248.014H549.407C547.198 248.014 545.407 246.224 545.407 244.014V192.173Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_26",
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 323.389C103.5 320.413 105.913 318 108.889 318H254.981C257.957 318 260.369 320.413 260.369 323.389V370.9C260.369 373.876 257.957 376.289 254.981 376.289H108.889C105.913 376.289 103.5 373.876 103.5 370.9V323.389Z",
    fill: "#313A53"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    opacity: 0.465472,
    d: "M154.614 352.149C154.614 351.173 155.405 350.383 156.381 350.383H185.749C186.725 350.383 187.516 351.173 187.516 352.149V352.149C187.516 353.124 186.725 353.915 185.749 353.915H156.381C155.405 353.915 154.614 353.124 154.614 352.149V352.149Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    d: "M154.614 342.14C154.614 341.164 155.405 340.373 156.381 340.373H173.999C174.974 340.373 175.765 341.164 175.765 342.14V342.14C175.765 343.115 174.974 343.906 173.999 343.906H156.381C155.405 343.906 154.614 343.115 154.614 342.14V342.14Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M212.343 340.535C212.847 339.425 214.154 338.935 215.261 339.441C215.627 339.608 215.94 339.872 216.166 340.204L216.247 340.331L220.567 347.695C220.609 347.765 220.699 347.788 220.769 347.747L220.787 347.734L220.804 347.718L223.103 345.113C223.909 344.199 225.302 344.114 226.213 344.922C226.273 344.975 226.33 345.031 226.384 345.09L226.462 345.181L229.834 349.331C229.885 349.394 229.977 349.403 230.04 349.352L230.058 349.335L230.072 349.315L235.398 340.691C236.038 339.654 237.396 339.334 238.431 339.975C238.591 340.075 238.738 340.194 238.867 340.331L238.961 340.436L241.442 343.408C241.807 343.845 241.749 344.494 241.313 344.859C240.902 345.204 240.301 345.172 239.928 344.8L239.865 344.73L237.384 341.758C237.374 341.746 237.362 341.736 237.349 341.728C237.291 341.692 237.219 341.701 237.172 341.745L237.147 341.775L231.821 350.4C231.692 350.609 231.529 350.795 231.339 350.95C230.428 351.693 229.102 351.586 228.321 350.727L228.239 350.632L224.867 346.483C224.862 346.476 224.857 346.471 224.851 346.465C224.8 346.42 224.727 346.417 224.673 346.452L224.643 346.478L222.344 349.083C222.191 349.257 222.011 349.406 221.811 349.523C220.797 350.121 219.501 349.813 218.859 348.842L218.795 348.739L214.474 341.376C214.459 341.349 214.436 341.329 214.408 341.316C214.347 341.288 214.276 341.306 214.235 341.356L214.214 341.389L210.004 350.647C209.847 350.992 209.605 351.29 209.301 351.513L209.184 351.593L204.192 354.782C203.714 355.088 203.078 354.947 202.773 354.467C202.484 354.014 202.594 353.421 203.01 353.098L203.087 353.044L208.078 349.855C208.094 349.845 208.108 349.832 208.119 349.817L208.133 349.792L212.343 340.535Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    cx: 132.582,
    cy: 347.733,
    rx: 12.0443,
    ry: 12.0698,
    fill: "#FFBF29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ElementCard3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_29",
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 175C103.5 170.582 107.082 167 111.5 167H251.977C256.395 167 259.977 170.582 259.977 175V291.215C259.977 295.633 256.395 299.215 251.977 299.215H111.5C107.082 299.215 103.5 295.633 103.5 291.215V175Z",
    fill: "#313A53"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 167,
    width: 157,
    height: 133
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 175C103.5 170.582 107.082 167 111.5 167H251.977C256.395 167 259.977 170.582 259.977 175V291.215C259.977 295.633 256.395 299.215 251.977 299.215H111.5C107.082 299.215 103.5 295.633 103.5 291.215V175Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    opacity: 0.414737,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.434 267.043C124.434 267.043 142.994 261.736 151.178 250.904C159.362 240.073 162.121 229.574 176.197 229.574C190.273 229.574 192.077 245.654 207.293 245.654C222.509 245.654 223.341 225.147 228.399 217.005C233.456 208.862 242.184 208.862 242.184 208.862V278.617C242.184 279.589 241.396 280.377 240.424 280.377H126.194C125.222 280.377 124.434 279.589 124.434 278.617V267.043Z",
    fill: "#FFE3B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path 3_2",
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.434 268.167C124.434 268.167 142.994 262.837 151.178 251.959C159.362 241.08 162.121 230.535 176.197 230.535C190.273 230.535 192.077 246.685 207.293 246.685C222.509 246.685 223.341 226.09 228.399 217.912C233.456 209.734 242.184 209.734 242.184 209.734",
    stroke: "#FFBF29",
    strokeWidth: 2.64,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    x: 115.711,
    y: 180.082,
    width: 48.8444,
    height: 5.23279,
    rx: 2.61639,
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32",
    opacity: 0.465472,
    d: "M115.711 195.78C115.711 194.335 116.882 193.164 118.327 193.164H135.772C137.217 193.164 138.389 194.335 138.389 195.78V195.78C138.389 197.225 137.217 198.397 135.772 198.397H118.327C116.882 198.397 115.711 197.225 115.711 195.78V195.78Z",
    fill: "#FFBF29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4",
    cx: 229.536,
    cy: 183.134,
    rx: 3.05278,
    ry: 3.05246,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_5",
    cx: 238.258,
    cy: 183.134,
    rx: 3.05278,
    ry: 3.05246,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6",
    cx: 246.981,
    cy: 183.134,
    rx: 3.05278,
    ry: 3.05246,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Chair1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.067 570.984C470.067 570.092 469.37 569.355 468.48 569.306L428.454 567.108H416.18L375.993 569.307C375.102 569.356 374.404 570.092 374.404 570.984V573.965H470.067V570.984Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.792 498.996H417.681V567.565H426.792V498.996Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    width: 13.6662,
    height: 15.9994,
    rx: 0.84,
    transform: "matrix(-1 0 0 1 429.069 557.966)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.625 494.808C433.625 494.344 433.249 493.968 432.785 493.968H411.688C411.224 493.968 410.848 494.344 410.848 494.808V502.085C410.848 502.428 411.057 502.737 411.375 502.865L416.392 504.878C416.491 504.918 416.597 504.939 416.705 504.939H427.768C427.876 504.939 427.982 504.918 428.081 504.878L433.098 502.865C433.416 502.737 433.625 502.428 433.625 502.085V494.808Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    width: 9.11077,
    height: 9.14254,
    rx: 2.1,
    transform: "matrix(-1 0 0 1 472.346 573.965)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    width: 9.11077,
    height: 9.14254,
    rx: 2.1,
    transform: "matrix(-1 0 0 1 381.238 573.965)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    width: 9.11077,
    height: 9.14254,
    rx: 2.1,
    transform: "matrix(-1 0 0 1 426.792 573.965)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.169 488.482C433.169 484.443 429.894 481.168 425.855 481.168L368.508 481.168C364.468 481.168 361.194 484.443 361.194 488.482V488.482C361.194 492.522 364.468 495.796 368.508 495.796H425.855C429.894 495.796 433.169 492.522 433.169 488.482V488.482Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.701 413.513H455.946C455.946 413.513 455.946 431.799 455.946 450.084C455.946 468.369 435.447 486.654 435.447 486.654H452.302C452.302 486.654 468.701 471.082 468.701 450.084C468.701 431.799 468.701 413.513 468.701 413.513Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.234 413.513H450.479C450.479 413.513 450.479 431.799 450.479 450.084C450.479 468.369 429.98 486.654 429.98 486.654H445.013C445.013 486.654 463.234 471.51 463.234 450.084C463.234 431.799 463.234 413.513 463.234 413.513Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.589 395.4C500.589 390.761 496.828 387 492.189 387H426.505C421.866 387 418.105 390.761 418.105 395.4V432.415C418.105 437.054 421.866 440.815 426.505 440.815H492.189C496.828 440.815 500.589 437.054 500.589 432.415V395.4Z",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.982 392.907C500.982 389.645 498.338 387 495.076 387V387C491.814 387 489.169 389.645 489.169 392.907V434.908C489.169 438.171 491.814 440.815 495.076 440.815V440.815C498.338 440.815 500.982 438.171 500.982 434.909L500.982 392.907Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.812 488.482C477.812 484.443 474.537 481.168 470.497 481.168L414.973 481.168C410.933 481.168 407.659 484.443 407.659 488.482V488.482C407.659 492.522 410.933 495.796 414.973 495.796H470.497C474.537 495.796 477.812 492.522 477.812 488.482V488.482Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wom2.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.609 538.415C377.609 538.415 382.855 549.01 378.554 552.349C374.247 555.688 362.871 561.946 362.871 561.946L393.011 560.052L386.311 536.944L377.609 538.415Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.025 548.003C389.076 548.455 390.636 552.712 387.299 552.413C383.963 552.115 381.868 547.714 379.408 548C376.947 548.285 375.385 552.717 370.7 555.803C366.017 558.89 359.072 562.572 359.537 565.675C360.002 568.779 370.931 569.61 376.468 568.582C382.005 567.556 384.589 565.33 388.181 565.507C391.773 565.685 394.031 565.245 395.157 562.939C396.282 560.632 391.119 547.48 390.025 548.003Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.759 562.167L389.452 562.149C385 561.774 381.946 564.574 377.709 565.363C373.471 566.153 362.296 566.426 360.511 563.775C360.426 563.65 360.348 563.521 360.275 563.391C359.675 564.128 359.393 564.917 359.538 565.836C360.003 568.789 370.933 569.58 376.47 568.603C382.007 567.626 384.592 565.507 388.184 565.676L388.823 565.7C392.046 565.788 394.102 565.294 395.161 563.232C395.418 562.729 395.36 561.649 395.102 560.283C393.599 561.311 391.703 562.226 389.759 562.167V562.167Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.011 445.032C413.887 445.439 363.101 456.672 353.875 458.58C344.648 460.488 336.847 470.814 343.883 482.772C351.785 496.194 372.175 534.314 377.126 542.907C379.576 547.16 391.937 544.775 389.034 537.636C383.621 524.329 381.107 490.898 367.307 478.709C367.307 478.709 413.717 486.786 433.764 477.534C448.333 470.808 445.037 444.047 423.011 445.032Z",
    fill: "#413C75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.359 388.074C359.359 388.074 359.463 382.65 356.865 378.77C354.268 374.89 354.165 370.768 352.2 370.903C350.234 371.038 352.18 380.618 352.18 380.618C352.18 380.618 349.687 379.665 347.895 378.46C346.104 377.255 340.671 371.314 339.401 372.367C337.249 374.161 340.716 384.279 342.604 386.302C344.499 388.326 353.848 393.98 353.848 393.98L381.383 421.719L385.5 406.994L359.359 388.074Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.434 385.625C410.189 395.47 402.417 413.556 399.213 418.951C395.198 425.708 388.866 428.686 381.453 423.672C379.902 422.623 375.448 418.954 375.448 418.954C376.107 412.532 378.506 407.164 382.642 402.849L385.451 405.172C385.451 405.172 393.417 384.752 399.825 372.924C405.374 362.69 420.895 370.659 414.434 385.625Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.368 405.183C385.368 405.183 383.229 412.44 382.729 412.019C382.228 411.599 383.111 403.286 383.111 403.286L385.368 405.183Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.778 347.411V356.123L439.175 350.972C439.175 350.972 441.142 342.626 442.741 336.427C443.744 332.539 446.187 319.384 436.351 320C428.293 305.796 404.827 314.587 404.64 331.94C404.416 352.811 404.599 360.937 404.599 360.937C417.869 361.698 425.337 359.78 432.778 347.411Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.313 363.997C439.313 363.997 433.363 362.6 433.156 352.85C432.95 343.099 433.095 339.77 433.095 339.77L419.987 339.534C419.987 339.534 419.844 350.401 419.842 354.332C419.836 363.889 412.808 364.672 412.808 364.672C412.808 364.672 414.009 372.558 425.887 373.226C435.16 373.748 439.313 363.997 439.313 363.997Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.15 334.901C441.998 334.675 441.044 343.235 434.97 343.224C434.97 343.224 431.442 355.384 419.192 355.384C409.244 355.384 408.597 341.211 408.507 338.383C408.41 335.369 408.398 325.465 408.398 325.465L436.378 325.452L436.15 334.901Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.603 334.845C434.18 335.245 434.474 336.849 433.815 336.709C430.469 335.997 416.925 336.936 415.181 329.488C413.011 334.141 412.48 335.285 407.702 336.534V322.899L437.924 320C437.924 320 437.455 334.704 436.603 334.845Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M421.554 347.215C421.554 347.215 418.636 349.685 415.257 347.372",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M419.628 350.075C418.72 350.494 417.846 350.525 417.066 350.107",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M435.554 339.505C435.494 338.132 435.913 337.041 437.313 336.822",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.984 363C430.516 367.574 421.882 369.251 413.845 364.284C400.73 390.145 397.461 421.002 400.616 455.106C419.741 462.678 435.815 461.189 449.5 452.534L437.984 363Z",
    fill: "#FFE4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.916 538.84C344.916 538.84 345.074 551.311 334.798 555.973C324.529 560.635 317.212 560.355 318.144 563.959C319.075 567.563 345.805 567.418 348.301 564.599C350.429 562.201 355.055 539.872 356.329 541.579L344.916 538.84Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.379 556.452C350.804 555.319 349.48 561.853 345.203 560.036C340.925 558.219 344.298 552.213 341.606 551.105C338.914 549.998 333.716 555.953 326.812 557.401C319.908 558.847 314.303 560.114 312.71 562.801C311.338 565.111 312.71 565.849 312.71 565.849C312.71 565.849 319.356 569.168 323.486 569.899C329.486 570.96 346.825 571.667 348.725 569.732C349.892 568.545 353.167 557.019 352.379 556.452Z",
    fill: "#EEDFE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.335 563.073C311.033 565.196 313.087 566.3 313.333 566.422L314.324 566.844C316.204 567.626 320.446 569.302 323.581 569.901C329.329 571 347.128 571.651 349.043 569.762C349.379 569.43 349.795 568.217 350.197 566.641L348.976 566.774C343.098 567.397 329.977 568.523 323.502 566.998C317.754 565.644 314.608 563.417 313.173 562.116C312.824 562.416 312.542 562.734 312.335 563.073Z",
    fill: "#EC7AA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.602 441.177C451.602 441.177 464.868 469.192 446.225 478.812C428.196 488.115 374.224 477.112 374.224 477.112C374.224 477.112 375.189 484.877 374.224 491.802C371.706 509.889 359.726 540.023 357.192 543.809C353.687 549.046 343.01 545.097 342.809 540.737C342.607 536.377 350.857 480.693 352.112 470.075C353.36 459.456 357.3 457.913 368.809 455.01C371.453 454.343 402.72 446.573 405.584 446.8C430.195 448.746 451.602 441.177 451.602 441.177Z",
    fill: "#524D87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.06 475.921C419.211 477.921 371.956 473.798 370.058 475.671C368.246 477.46 368.549 508.575 364.484 526.585L365.102 524.884C368.925 514.267 372.894 501.354 374.224 491.802C375.189 484.877 374.224 477.112 374.224 477.112L376.401 477.533C386.66 479.46 430.36 486.999 446.225 478.812C454.822 474.376 458.33 467.006 456.749 456.703C454.027 468.349 447.464 474.755 437.06 475.921Z",
    fill: "white",
    fillOpacity: 0.056108
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.658 363.021C425.289 403.538 417.872 460.979 456.5 450.986C435.981 413.206 463.876 396.202 457.553 376.676C455.391 370 437.819 362.497 437.658 363.021Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.607 379.845C437.628 381.955 449.152 406.362 444.537 410.039C439.923 413.716 431.891 414.113 431.025 416.359C429.285 420.874 437.699 432.271 456.267 450.551L456.5 450.986C438.625 418.076 457.488 400.931 458.469 384.151C456.398 380.903 454.11 379.468 451.607 379.845Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.5 364C409.78 375.838 407.511 385.127 405.394 402.503C403.629 416.975 404.513 446.84 404.513 446.84L398.68 447.987C398.68 447.987 394.51 401.848 395.904 395.907C398.244 385.938 399.829 380.113 402.918 371C404.62 365.998 414.5 364 414.5 364Z",
    fill: "#EA5455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.06 409.017C435.06 409.017 427.445 401.392 424.807 400.507C422.17 399.622 407.723 398.559 407.821 400.559C407.932 402.701 417.228 402.578 418.088 403.632C418.947 404.685 420.143 412.888 423.392 413.697C426.635 414.506 433.358 416.9 433.358 416.9L463.282 432.361L460.094 416.901L435.06 409.017Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.981 376.731C467.058 389.542 474.808 409.056 477.783 416.664C480.757 424.272 477.757 435.747 464.676 433.494C463.119 433.226 460.585 432.24 460.585 432.24C455.776 425.647 454.932 419.987 456.727 414.947C456.727 414.947 458.419 415.661 458.419 415.661C458.419 415.661 445.418 392.617 442.243 386.439C436.94 376.122 449.986 365.444 457.981 376.731Z",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.418 415.661C458.418 415.661 465.022 418.886 464.191 417.468C463.361 416.049 455.903 411.182 455.903 411.182L458.418 415.661Z",
    fill: "black",
    fillOpacity: 0.159856
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.638 436.555H300.638V584.135H288.638V436.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.638 436.555H294.638V584.135H286.638V436.555Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.475 436.555H223.475V584.135H211.475V436.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.475 436.555H217.475V584.135H209.475L209.475 436.555Z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 25_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.133 436.555H505.133V584.135H493.133V436.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.133 436.555H499.133V584.135H491.133L491.133 436.555Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.97 436.555L422.97 436.555V584.135H410.97V436.555Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.97 436.555H416.97V584.135H408.97V436.555Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_54",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.269 433.68C292.269 432.752 293.021 432 293.949 432H506.952C507.88 432 508.632 432.752 508.632 433.68V449.32C508.632 450.248 507.88 451 506.952 451H293.949C293.021 451 292.269 450.248 292.269 449.32V433.68Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.976 433.68C200.976 432.752 201.728 432 202.656 432H414.746C415.674 432 416.426 432.752 416.426 433.68V449.32C416.426 450.248 415.674 451 414.746 451H202.656C201.728 451 200.976 450.248 200.976 449.32V433.68Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    x: 182.5,
    y: 432,
    width: 338,
    height: 9.76056,
    rx: 4.88028,
    fill: "#EFEFEF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pot5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.854 400.469V396.281L264.138 396.28L264.138 394.06C264.138 392.833 265.124 391.838 266.339 391.838C267.555 391.838 268.541 392.833 268.541 394.06V398.692C268.541 399.674 267.752 400.469 266.78 400.469H258.854Z",
    fill: "#02B596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.199 402.881V398.883C244.199 397.656 245.185 396.662 246.401 396.662C247.617 396.662 248.602 397.656 248.602 398.883L248.602 401.103H251.243L251.244 390.887C251.244 388.188 253.412 386 256.087 386C258.762 386 260.93 388.188 260.93 390.887V416.208H251.244L251.243 405.545L246.841 405.546C245.382 405.546 244.199 404.353 244.199 402.881Z",
    fill: "#02D3AF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.618 409.269H266.982L265.383 430.79C265.339 431.378 264.853 431.833 264.268 431.833H247.333C246.748 431.833 246.262 431.378 246.218 430.79L244.618 409.269Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_58",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.618 409.269H266.982C267.6 409.269 268.101 409.774 268.101 410.397V414.91C268.101 415.533 267.6 416.039 266.982 416.039H244.618C244.001 416.039 243.5 415.533 243.5 414.91V410.397C243.5 409.774 244.001 409.269 244.618 409.269Z",
    fill: "#FFB3A4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "FacingBack Laptop3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.174 431.027C317.174 430.195 317.849 429.52 318.681 429.52H423.938C424.77 429.52 425.445 430.195 425.445 431.027V431.027C425.445 431.86 424.77 432.535 423.938 432.535H318.681C317.849 432.535 317.174 431.86 317.174 431.027V431.027Z",
    fill: "#8F84FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_60",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.496 431.027C388.496 430.195 389.171 429.52 390.004 429.52H423.937C424.77 429.52 425.445 430.195 425.445 431.027V431.027C425.445 431.86 424.77 432.535 423.937 432.535H390.004C389.171 432.535 388.496 431.86 388.496 431.027V431.027Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.019 388.056C311.743 385.905 313.42 384 315.589 384H381.858C383.67 384 385.199 385.346 385.429 387.144L390.344 425.593C390.619 427.745 388.942 429.65 386.773 429.65H320.505C318.693 429.65 317.163 428.303 316.934 426.506L312.019 388.056Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.019 388.056C311.743 385.905 313.42 384 315.589 384H379.524C381.335 384 382.865 385.346 383.095 387.144L388.01 425.593C388.285 427.745 386.608 429.65 384.439 429.65H320.505C318.693 429.65 317.163 428.303 316.934 426.506L312.019 388.056Z",
    fill: "#B1A9FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_7",
    cx: 348.815,
    cy: 407.551,
    rx: 4.64831,
    ry: 5.07496,
    transform: "rotate(-37 348.815 407.551)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.5 422C438.5 421.448 438.948 421 439.5 421H485C488.038 421 490.5 423.462 490.5 426.5V426.5C490.5 429.538 488.038 432 485 432H439.5C438.948 432 438.5 431.552 438.5 431V422Z",
    fill: "#F16B79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_64",
    d: "M438.5 424.2C438.5 423.648 438.948 423.2 439.5 423.2L465.533 423.2C467.356 423.2 468.833 424.677 468.833 426.5V426.5C468.833 428.322 467.356 429.8 465.533 429.8H439.5C438.948 429.8 438.5 429.352 438.5 428.8V424.2Z",
    fill: "#EAEFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    width: 131.195,
    height: 198.348,
    rx: 7.68,
    transform: "matrix(-1 0 0 1 673.5 386)",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    width: 95.7932,
    height: 198.348,
    rx: 7.68,
    transform: "matrix(-1 0 0 1 638.099 386)",
    fill: "#BFE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_67",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.769 527.304C629.769 523.062 626.33 519.624 622.089 519.624H558.315C554.073 519.624 550.635 523.062 550.635 527.304V568.316C550.635 572.558 554.073 575.996 558.315 575.996H622.089C626.33 575.996 629.769 572.558 629.769 568.316V527.304Z",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_68",
    d: "M602.696 519.624H577.707V526.223C577.707 528.344 579.426 530.063 581.547 530.063H598.856C600.977 530.063 602.696 528.344 602.696 526.223V519.624Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.769 407.226C629.769 406.121 628.873 405.226 627.769 405.226H558.315C554.073 405.226 550.635 408.664 550.635 412.906V443.044C550.635 447.286 554.073 450.724 558.315 450.724H627.769C628.873 450.724 629.769 449.829 629.769 448.724V407.226Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_70",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.414 402.032C612.414 397.79 608.976 394.352 604.734 394.352H540.961C536.719 394.352 533.281 397.79 533.281 402.032V443.044C533.281 447.286 536.719 450.724 540.961 450.724H604.734C608.976 450.724 612.414 447.286 612.414 443.044V402.032Z",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_71",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.769 464.668C629.769 460.426 626.33 456.988 622.089 456.988H558.315C554.073 456.988 550.635 460.426 550.635 464.668V505.68C550.635 509.922 554.073 513.36 558.315 513.36H622.089C626.33 513.36 629.769 509.922 629.769 505.68V464.668Z",
    fill: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_72",
    d: "M602.696 456.988H577.707V463.587C577.707 465.708 579.426 467.427 581.547 467.427H598.856C600.977 467.427 602.696 465.708 602.696 463.587V456.988Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_73",
    d: "M585.343 394.352H560.353V400.951C560.353 403.072 562.072 404.791 564.193 404.791H581.503C583.624 404.791 585.343 403.072 585.343 400.951V394.352Z",
    fill: "#91D6FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Table Frame2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.861 364.677H619.901L627.5 385.354H620.46L612.861 364.677Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.925 344.633C594.004 344.264 594.33 344 594.707 344H626.512C627.02 344 627.4 344.469 627.294 344.967L618.835 384.72C618.756 385.09 618.43 385.354 618.052 385.354H586.248C585.739 385.354 585.36 384.885 585.465 384.387L593.925 344.633Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_76",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.165 344.633C592.244 344.264 592.57 344 592.948 344H624.752C625.261 344 625.64 344.469 625.534 344.967L617.075 384.72C616.996 385.09 616.67 385.354 616.292 385.354H584.488C583.979 385.354 583.6 384.885 583.706 384.387L592.165 344.633Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_77",
    d: "M593.903 346.293C593.973 345.961 594.267 345.723 594.607 345.723H622.211C622.669 345.723 623.011 346.145 622.916 346.593L615.339 382.199C615.268 382.532 614.974 382.769 614.634 382.769H587.03C586.572 382.769 586.23 382.347 586.326 381.899L593.903 346.293Z",
    fill: "#B3FFEB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 345,
    width: 37,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_78",
    d: "M593.903 346.293C593.973 345.961 594.267 345.723 594.607 345.723H622.211C622.669 345.723 623.011 346.145 622.916 346.593L615.339 382.199C615.268 382.532 614.974 382.769 614.634 382.769H587.03C586.572 382.769 586.23 382.347 586.326 381.899L593.903 346.293Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8",
    cx: 602.75,
    cy: 356.385,
    rx: 3.85,
    ry: 3.76923,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_9",
    cx: 591.476,
    cy: 384.654,
    rx: 17.875,
    ry: 17.5,
    fill: "#6DE9C9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10",
    cx: 619.526,
    cy: 379.538,
    rx: 21.175,
    ry: 20.4615,
    fill: "#83F2D5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.116 301.293C102.393 298.58 101.621 282.588 110.534 277.041C101.342 257.892 122.598 238.879 137.159 250.605C146.704 246.544 154.637 262.389 145.755 274.695C149.479 295.826 141.899 301.287 128.236 301.519L114.116 301.293Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.262 297.474C114.262 297.474 119.965 296.143 120.162 286.857C120.36 277.57 120.221 274.4 120.221 274.4L132.783 274.175C132.783 274.175 132.92 284.525 132.922 288.268C132.927 298.323 139.977 297.474 139.977 297.474C139.977 297.474 138.512 305.626 127.129 306.262C118.242 306.76 114.262 297.474 114.262 297.474Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.294 269.763C111.69 269.548 112.604 277.7 118.425 277.689C118.425 277.689 121.807 289.27 133.545 289.27C143.079 289.27 143.699 275.772 143.785 273.079C143.878 270.208 143.89 260.776 143.89 260.776L117.076 260.764L117.294 269.763Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M131.282 281.49C131.282 281.49 134.078 283.843 137.316 281.64",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M133.128 284.215C133.998 284.614 134.835 284.643 135.583 284.245",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8_2",
    d: "M117.865 274.148C117.922 272.84 117.521 271.801 116.179 271.593",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.407 268.756C116.407 268.756 119.478 272.852 120.1 272.874C120.722 272.895 120.94 267.547 120.94 267.547C124.708 267.261 134.244 265.373 136.581 260.977C138.216 264.856 141.341 266.579 143.394 266.248L143.783 274.489L144.741 257.922H115.655L116.407 268.756Z",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.552 302.329C189.552 302.329 187.878 292.988 188.48 291.097C188.994 289.462 193.852 287.104 193.852 287.104C193.852 287.104 202.303 273.736 204.152 275.097C205.656 276.201 199.751 286.057 199.751 286.057C199.751 286.057 205.136 291.714 205.061 294.243C204.986 296.772 196.272 304.689 196.272 304.689L189.552 302.329Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.034 286.97C194.034 286.97 197.777 286.46 198.372 287.627C198.88 288.621 195.771 291.439 195.771 292.232C195.771 293.024 195.815 299.021 196.065 299.076C196.315 299.13 199.814 289.289 199.068 287.207C198.454 285.499 194.034 286.97 194.034 286.97Z",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.05 301.224C139.433 298.889 132.632 305.592 136.775 311.991C143.395 322.223 167.833 349.088 179.097 349.128C189.215 349.163 198.51 308.919 198.297 305.712C198.084 302.504 189.871 298.49 186.888 300.756C183.897 303.022 174.438 329.569 174.438 329.569C174.438 329.569 150.755 303.598 145.05 301.224Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.438 329.569C174.438 329.569 177.634 335.072 177.929 334.249C178.224 333.426 175.597 326.333 175.597 326.333L174.438 329.569Z",
    fill: "black",
    fillOpacity: 0.302803
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.846 557.709C137.846 557.709 136.726 566.915 140.903 570.431C145.079 573.946 128.967 572.677 128.967 572.677L128.85 557.562L137.846 557.709Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.814 565.868C130.249 565.945 130.02 570.26 131.945 570.08C133.869 569.899 137.123 565.598 139.913 567.044C142.809 568.549 158.681 578.602 159.615 581.186C160.661 584.066 153.892 584.281 149.053 584.071C144.208 583.86 141.975 581.68 139.623 581.734C137.266 581.788 136.709 583.257 134.946 583.662C133.157 584.073 128.684 584.011 128.269 582.724C127.836 581.388 127.385 565.79 128.814 565.868Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.5 370C112.5 370 122.13 462.719 122.916 471.191C123.702 479.663 122.13 485.797 121.486 494.548C120.841 503.298 123.943 558.332 123.943 558.332C128.503 561.086 133.93 561.627 140.829 558.415C140.829 558.415 147.165 489.856 147.103 474.241C147.066 464.926 148.031 371.046 148.031 371.046L112.5 370Z",
    fill: "#2B256A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.888 471.952C128.679 477.818 126.554 488.928 121.513 505.283L121.45 502.594C121.378 499.038 121.375 496.265 121.473 494.726L121.485 494.548C122.108 486.089 123.598 480.075 122.987 472.031L122.854 470.544C122.524 467.116 121.498 457.058 120.212 444.553L120.918 446.596C124.823 458.002 127.146 466.454 127.888 471.952Z",
    fill: "white",
    fillOpacity: 0.0771689
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.595 568.068L140.947 569.056C140.635 569.533 140.784 570.175 141.275 570.465L150.841 576.116C151.135 576.289 151.496 576.301 151.8 576.147L153.077 575.503C149.357 572.797 145.63 570.376 141.595 568.068Z",
    fill: "white",
    fillOpacity: 0.540975
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9589 559.204L97.7676 573.234L87.4004 573.508L89.349 559.204H96.9589Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3035 568.367C94.6508 573.908 97.4701 566.975 98.0964 567.663C99.2881 568.97 101.544 581.991 100.316 583.816C99.2334 585.432 84.5004 585.459 83.6856 583.937C82.6155 581.921 86.4864 567.751 87.3035 568.367Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_79",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5776 572.806C90.6568 572.322 91.0746 571.967 91.5645 571.967H93.6388C94.1288 571.967 94.5466 572.322 94.6257 572.806L95.2417 576.569C95.3414 577.178 94.8716 577.73 94.2549 577.73H90.9485C90.3317 577.73 89.862 577.178 89.9616 576.569L90.5776 572.806Z",
    fill: "white",
    fillOpacity: 0.540975
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.591 367C106.591 367 96.2663 376.305 93.5556 389.673C89.0369 411.957 91.311 453.115 91.1772 462.14C91.0495 471.165 87.8042 476.611 86.0635 489.372C84.3229 502.132 86.0453 559.162 86.0453 559.162C90.6604 561.947 95.6646 562.146 101.167 558.995L133.485 369.977L106.591 367Z",
    fill: "#38308B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.713 375.305L103.746 375.86C100.203 382.638 98.4124 398.097 98.3755 422.235L98.3749 423C98.3749 459.496 91.7866 472.353 89.136 488.064L89.0569 488.541C87.4692 498.284 86.28 513.897 85.4891 535.38L85.4087 530.054C85.1886 513.824 85.1838 495.821 86.0635 489.372C87.8042 476.611 91.0495 471.165 91.1772 462.14L91.183 461.243C91.1807 450.663 89.1725 411.289 93.5556 389.673C94.7004 384.027 97.2033 379.106 99.713 375.305Z",
    fill: "white",
    fillOpacity: 0.0771689
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5 304.703C95.5 304.703 105.388 337.837 105.681 344.109C105.973 350.381 97.5934 368.816 99.0202 373.475C102.31 384.243 144.309 388.879 148.814 374.395C150.739 368.209 147.038 361.576 148.833 353.617C150.621 345.657 155.875 333.828 151.799 322.708C147.722 311.587 148.814 301.299 145.898 299.354C142.982 297.409 136.166 295.344 136.166 295.344C132.852 300.226 121.662 300.155 116.322 295C116.322 295 103.058 297.575 95.5 304.703Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.36 310.07C110.951 320.537 110.931 338.762 114.471 341.149C118.011 343.536 131.788 341.193 131.788 343.084C131.788 344.974 112.749 362.297 115.874 370.578C117.511 374.914 117.067 378.793 114.543 382.216L113.719 382.036C106.217 380.339 100.186 377.293 99.0198 373.476C97.593 368.816 105.973 350.381 105.68 344.109C105.432 338.802 98.3152 314.264 96.1309 306.838C98.0612 303.345 100.804 304.422 104.36 310.07Z",
    fill: "black",
    fillOpacity: 0.0564904
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.217 364.039C125.217 364.039 131.651 361.187 133.733 361.195C135.816 361.203 137.409 361.271 137.409 361.271L137.415 364.155C137.415 364.155 147.987 365.116 149.102 365.078C150.224 365.041 145.024 372.862 141.523 374.278C137.655 375.842 124.511 371.203 124.511 371.203L125.217 364.039Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0645 303.761C87.9583 309.675 67.2651 360.417 77.0942 367.534C85.4731 373.602 121.071 374.394 123.705 372.458C125.899 370.841 127.132 365.922 125.068 363.235C122.329 359.652 91.4412 354.477 91.4412 354.477C91.4412 354.477 102.547 327.908 104.865 323.251C112.816 307.266 107.548 295.386 96.0645 303.761Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4844 354.445C91.4844 354.445 87.9492 359.983 88.677 360.121C89.4048 360.259 94.1493 354.95 94.1493 354.95L91.4844 354.445Z",
    fill: "black",
    fillOpacity: 0.302803
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 200.73,
    y: 0.358094,
    width: 145.436,
    height: 145.436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07742,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 85.5,
    y: 301,
    width: 206.869,
    height: 108.289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.121569 0 0 0 0 0.223529 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 83.5,
    y: 148,
    width: 212.477,
    height: 188.215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.121569 0 0 0 0 0.223529 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 116.113,
    y: 207.414,
    width: 134.39,
    height: 75.0731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.144395 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 73.4904,
    y1: 161.402,
    x2: 73.4904,
    y2: 583.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 398.226,
    y1: 530.858,
    x2: 396.63,
    y2: 560.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 393.595,
    y1: 358.529,
    x2: 389.355,
    y2: 419.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 447.942,
    y1: 334.528,
    x2: 436.717,
    y2: 384.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 447.185,
    y1: 325.112,
    x2: 440.525,
    y2: 357.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 362.95,
    y1: 532.061,
    x2: 361.389,
    y2: 565.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 472.879,
    y1: 391.401,
    x2: 471.372,
    y2: 430.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 268.738,
    y1: 412.373,
    x2: 247.712,
    y2: 412.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 586.58,
    y1: 334.59,
    x2: 586.58,
    y2: 385.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FF6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 105.891,
    y1: 269.408,
    x2: 116.403,
    y2: 316.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 106.719,
    y1: 260.44,
    x2: 113.026,
    y2: 291.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 184.593,
    y1: 274.663,
    x2: 195.866,
    y2: 304.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 126.644,
    y1: 553.829,
    x2: 128.06,
    y2: 572.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 85.6065,
    y1: 555.722,
    x2: 87.1178,
    y2: 572.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 118.948,
    y1: 361.043,
    x2: 120.705,
    y2: 376.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterDark);
export default __webpack_public_path__ + "static/media/register-dark.2b05170793bfccb2fa3207559cbcda4e.svg";
export { ForwardRef as ReactComponent };